import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '@ui-nuvertos/shared';
import { getServiceUrl } from '../../utils/module-name-mapper';

export interface ColumnPreferenceRequest {
  module_name: string;
  columns_list: any[];
}

export interface ColumnPreferenceUpdateRequest {
  columns_list: any[];
}

export interface ColumnPreferenceResponse {
  data: {
    id: string | number; // Backend may return as number (JSONInt64), always convert to string
    user_id: string | number;
    module_name: string;
    columns_list: any[];
    created_at: string;
    updated_at: string;
  };
  message?: string;
  status?: string;
}

@Injectable({
  providedIn: 'root'
})
export class ColumnPreferenceService {
  constructor(private http: HttpClient) {}

  private getBaseUrl(moduleName?: string): string {
    return getServiceUrl(moduleName || '', environment as Record<string, any>);
  }

  /**
   * Get column preference by module name for the current user
   * Endpoint: GET /api/v1/column-preferences/filters?module_name=xxx
   */
  getByModuleName(moduleName: string): Observable<ColumnPreferenceResponse> {
    const baseUrl = this.getBaseUrl(moduleName);
    return this.http.get<ColumnPreferenceResponse>(
      `${baseUrl}/api/v1/column-preferences/filters`,
      { params: { module_name: moduleName }, withCredentials: true }
    );
  }

  /**
   * Create a new column preference
   * Endpoint: POST /api/v1/column-preferences
   */
  createColumnPreference(request: ColumnPreferenceRequest): Observable<ColumnPreferenceResponse> {
    const baseUrl = this.getBaseUrl(request.module_name);
    return this.http.post<ColumnPreferenceResponse>(
      `${baseUrl}/api/v1/column-preferences/`,
      request,
      { withCredentials: true }
    );
  }

  /**
   * Update an existing column preference
   * Endpoint: PUT /api/v1/column-preferences/:id
   * @param moduleName - optional module name to route to the correct backend
   */
  updateColumnPreference(id: string, request: ColumnPreferenceUpdateRequest, moduleName?: string): Observable<ColumnPreferenceResponse> {
    const baseUrl = this.getBaseUrl(moduleName);
    return this.http.put<ColumnPreferenceResponse>(
      `${baseUrl}/api/v1/column-preferences/${id}`,
      request,
      { withCredentials: true }
    );
  }
}

